import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  CircularProgress
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AvailabilityMeetingPlace } from '@/core/models/meeting-link.model'
import { Network } from '@/core/models/network.model'

interface Props {
  open: boolean
  onClose: () => void
  networks: Network[]
  onConvert: (networkId: string) => void
  meetingPlace: AvailabilityMeetingPlace
  isConverting?: boolean
}

export const ConvertOrderDialog = ({
  open,
  onClose,
  networks,
  onConvert,
  meetingPlace,
  isConverting = false
}: Props) => {
  const { t } = useTranslation()
  const [selectedNetwork, setSelectedNetwork] = useState('')

  const handleConvert = () => {
    onConvert(selectedNetwork)
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={isConverting}
      onBackdropClick={isConverting ? undefined : onClose}
    >
      <DialogTitle>
        {meetingPlace === AvailabilityMeetingPlace.SECOND_OPINION
          ? t('page.meetingLink.convertDialog.toExpertise')
          : t('page.meetingLink.convertDialog.toConsultation')}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {t('page.meetingLink.convertDialog.selectNetwork')}
        </Typography>
        <FormControl fullWidth>
          <InputLabel>{t('common:field.network.label')}</InputLabel>
          <Select
            value={selectedNetwork}
            onChange={(e) => setSelectedNetwork(e.target.value)}
            label={t('common:field.network.label')}
            disabled={isConverting}
          >
            {networks.map((network) => (
              <MenuItem key={network._id} value={network._id}>
                {network.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isConverting}>
          {t('common:button.cancel.label')}
        </Button>
        <Button
          onClick={handleConvert}
          variant="contained"
          color="primary"
          disabled={!selectedNetwork || isConverting}
          startIcon={isConverting && <CircularProgress size={20} />}
        >
          {t('page.meetingLink.convertDialog.convert')}
        </Button>
      </DialogActions>
    </Dialog>
  )
} 